<template>
  <div class="container" id="advertise">
    <section>
      <div class="row">
        <div class="col-12">
          <div class="page section-group">
            <div class="card p-5">
              <h1 class="page-title mb-2">{{$t('common.advertise.Advertisingcooperation')}}</h1>
              <hr class="divider" />
              <div class="page-content ad-content mb-4">
                <div class="section-group">
                  <h3>{{$t('common.advertise.Advertisinginquiry')}}</h3>
                  <p>
                    {{$t('common.advertise.t1')}}<br />
                    <i class="fa fa-phone-alt fa-fw mr-2"></i>886-2-8792-9897
                    (分機806)<br />
                    <i class="fa fa-envelope fa-fw mr-2"></i
                    ><a href="mailto:sales_tw@soonnet.org"
                      >sales_tw@soonnet.org</a
                    >
                  </p>
                </div>
                <div class="section-group">
                  <h3>{{$t('common.advertise.Current')}}</h3>
                  <p>
                    {{$t('common.advertise.JPG')}}<br />
                    {{$t('common.advertise.MP4')}}
                  </p>
                  <table class="ad-table">
                    <tbody>
                      <tr>
                        <td>{{$t('common.advertise.code')}}</td>
                        <td class="w-25">{{$t('common.advertise.Displayposition')}}</td>
                        <td class="w-25">{{$t('common.advertise.Detailed')}}</td>
                        <td>{{$t('common.advertise.dimensions')}}</td>
                        <td class="w-25">{{$t('common.advertise.Fileformat')}}</td>
                      </tr>
                      <tr>
                        <td>M-1</td>
                        <td>
                          <img
                            src="../../assets/images/footer/ads-demo/M-1.png"
                          />
                        </td>
                        <td>{{$t('common.advertise.banner')}}</td>
                        <td>800x450</td>
                        <td>JPG / PNG / GIF</td>
                      </tr>
                      <tr>
                        <td>M-2</td>
                        <td>
                          <img
                            src="../../assets/images/footer/ads-demo/M-2.png"
                          />
                        </td>
                        <td>{{$t('common.advertise.detachable')}}</td>
                        <td>728x90</td>
                        <td>JPG / PNG / GIF</td>
                      </tr>
                      <tr>
                        <td>A</td>
                        <td>
                          <img
                            src="../../assets/images/footer/ads-demo/A.png"
                          />
                        </td>
                        <td>{{$t('common.advertise.homepage')}}</td>
                        <td>
                          {{$t('common.advertise.unlimited')}}<br />
                          {{$t('common.advertise.Image')}}
                        </td>
                        <td>JPG / PNG / GIF / MP4</td>
                      </tr>
                      <tr>
                        <td>B</td>
                        <td>
                          <img
                            src="../../assets/images/footer/ads-demo/B.png"
                          />
                        </td>
                        <td>{{$t('common.advertise.Largebanner')}}</td>
                        <td>800x450</td>
                        <td>JPG / PNG / GIF</td>
                      </tr>
                      <tr>
                        <td>C</td>
                        <td>
                          <img
                            src="../../assets/images/footer/ads-demo/C.png"
                          />
                        </td>
                        <td>{{$t('common.advertise.Largebanner-2')}}</td>
                        <td>
                          {{$t('common.advertise.imageshould')}}<br />
                          {{$t('common.advertise.Image')}}
                        </td>
                        <td>JPG / PNG / GIF / MP4</td>
                      </tr>
                      <tr>
                        <td>D</td>
                        <td>
                          <img
                            src="../../assets/images/footer/ads-demo/D.png"
                          />
                        </td>
                        <td>{{$t('common.advertise.category')}}</td>
                        <td>728x90</td>
                        <td>JPG / PNG / GIF</td>
                      </tr>
                      <tr>
                        <td>SM-1</td>
                        <td>
                          <img
                            src="../../assets/images/footer/ads-demo/SM-1_facebook.png"
                          />
                        </td>
                        <td>
                          <a
                            href="https://www.facebook.com/soonnet/"
                            target="_blank"
                            >FB</a
                          >
                          {{$t('common.advertise.Cover')}}
                        </td>
                        <td>{{$t('common.advertise.Refer')}}</td>
                        <td>JPG / PNG / MP4 / MOV</td>
                      </tr>
                      <tr>
                        <td>SM-2</td>
                        <td>
                          <img
                            src="../../assets/images/footer/ads-demo/SM-2_facebook.png"
                          /><img
                            src="../../assets/images/footer/ads-demo/SM-2_instagram.png"
                          />
                        </td>
                        <td>
                          {{$t('common.advertise.in')}}
                          <a
                            href="https://www.facebook.com/soonnet/"
                            target="_blank"
                            >FB</a
                          >
                          {{$t('common.advertise.or')}}
                          <a
                            href="https://www.instagram.com/soonnettv/"
                            target="_blank"
                            >IG</a
                          >
                          {{$t('common.advertise.Publish')}}
                        </td>
                        <td>{{$t('common.advertise.unlimited-2')}}</td>
                        <td>JPG / PNG / MP4 / MOV</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="section-group">
                  <h3>{{$t('common.advertise.advertising')}}</h3>
                  <table class="ad-table">
                    <tbody>
                      <tr>
                        <td>{{$t('common.advertise.code')}}</td>
                        <td class="w-25">{{$t('common.advertise.Display')}}</td>
                        <td class="w-25">{{$t('common.advertise.Detailed')}}</td>
                        <td>{{$t('common.advertise.dimensions')}}</td>
                        <td class="w-25">{{$t('common.advertise.Fileformat')}}</td>
                      </tr>
                      <tr>
                        <td>N-1</td>
                        <td>
                          <img
                            src="../../assets/images/footer/ads-demo/N-1_video.png"
                          /><img
                            src="../../assets/images/footer/ads-demo/N-1_search.png"
                          />
                        </td>
                        <td>
                          {{$t('common.advertise.Right')}}<br />
                          (<a
                            href="https://www.soonnet.org/video"
                            target="_blank"
                            >{{$t('common.advertise.Audio')}}</a
                          >、<a
                            href="https://www.soonnet.org/search"
                            target="_blank"
                            >{{$t('common.advertise.Searchpage')}}</a
                          >)
                        </td>
                        <td>300x600</td>
                        <td>JPG / PNG / GIF</td>
                      </tr>
                      <tr>
                        <td>N-2</td>
                        <td>
                          <img
                            src="../../assets/images/footer/ads-demo/N-2_articlelist.png"
                          /><img
                            src="../../assets/images/footer/ads-demo/N-2_articleview.png"
                          /><img
                            src="../../assets/images/footer/ads-demo/N-2_videowatch.png"
                          /><!--<img src="../../assets/images/footer/ads-demo/N-2_eventlist.png"><img src="../../assets/images/footer/ads-demo/N-2_eventview.png">-->
                        </td>
                        <td>
                          {{$t('common.advertise.squarebanner')}}<br />(<a
                            href="https://www.soonnet.org/articleList"
                            target="_blank"
                            >{{$t('common.advertise.topic')}}</a
                          >、<a
                            href="https://www.soonnet.org/articleview?id=145694"
                            target="_blank"
                            >{{$t('common.advertise.Topicinsidepage')}}</a
                          >、<a
                            href="https://www.soonnet.org/videowatch/16033/video"
                            target="_blank"
                            >{{$t('common.advertise.Insidepage')}}</a
                          ><!--、<a href="https://www.soonnet.org/eventList" target="_blank">活動</a>、<a href="https://www.soonnet.org/eventview/5414" target="_blank">活動內頁</a>-->)
                        </td>
                        <td>300x250</td>
                        <td>JPG / PNG / GIF</td>
                      </tr>
                      <tr>
                        <td>N-3</td>
                        <td>
                          <img
                            src="../../assets/images/footer/ads-demo/N-3_videolist.png"
                          />
                        </td>
                        <td>
                          {{$t('common.advertise.Longbanner')}}<br />(<a
                            href="https://www.soonnet.org/videolist"
                            target="_blank"
                            >{{$t('common.advertise.Movie')}}</a
                          >)
                        </td>
                        <td>728x90</td>
                        <td>JPG / PNG / GIF</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {},
  created() {
    this.$store.dispatch("updateCurrentIndex", 0);
  },
};
</script>


// WEBPACK FOOTER //
// src/components/common/advertise.vue